import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    viewBox="0 0 33 28"
    {...props}
  >
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M6.838 21.37h4.74v-6.248c0-.748-.606-1.354-1.354-1.354H8.192c-.748 0-1.354.606-1.354 1.354zm7.45 0h4.741V10.866c0-.748-.606-1.354-1.355-1.354h-2.031c-.749 0-1.355.606-1.355 1.354v10.506Zm7.45 0h4.742V8.128c0-.748-.607-1.355-1.355-1.355h-2.032c-.748 0-1.355.607-1.355 1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBars;
